import {
  GET_SMALLER_COMPANIES_COMPARED,
  GET_SMALLER_COMPANIES_COMPARED_SUCCESS,
  GET_SMALLER_COMPANIES_COMPARED_ERROR
} from './SmallerCompaniesCompared.actions'

const initialState = {
  data: [],
  series: [],
  csv: [],
  loading: false,
  error: null
}

/**
 * The smaller Companies Compared's reducer.
 */
const smallerCompaniesComparedReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_SMALLER_COMPANIES_COMPARED:
      return { ...state, loading: true }
    case GET_SMALLER_COMPANIES_COMPARED_SUCCESS:
      return { ...state, loading: false, data: payload.data, series: payload.series, csv: payload.csv }
    case GET_SMALLER_COMPANIES_COMPARED_ERROR:
      return { ...state, loading: false, error: payload, data: [], series: [], csv: [] }
    default:
      return state
  }
}

export default smallerCompaniesComparedReducer
